<template>
    <section class="sections-tags-slider" v-if="sectionsTags">
        <DefSlider
                :pagination="false"
                :settings="settings"
                :nav="true"
                ref="slider"
        >
            <div v-for="item in sectionsTags" class="swiper-slide">
                <SectionTagCard :result="item"/>
            </div>
        </DefSlider>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import DefSlider from "../Def/DefSlider/DefSlider.vue";
    import SectionTagCard from "../card/SectionTagCard/SectionTagCard.vue";
    export default {
        name: 'SectionsTagsSlider',
      components: {SectionTagCard, DefSlider},
        selector: '.sections-tags-slider',

        data() {
            return {
                settings: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                    autoplay: {
                        delay: 5000,
                    },
                    breakpoints: {
                        430: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 10,
                            spaceBetween: 24
                        },
                    }
                },
            }
        },
        computed: {
            ...mapState({
                sectionsTags: ({ results }) => results?.sectionsTags,
            }),
        },
        // methods: {
        //     page() {
        //         return window.sessionStorage.getItem('page');
        //     }
        // },
    }
</script>

<style lang="scss" scoped>
    .sections-tags-slider{
        /*margin-bottom: 52px;*/
        @include point-md{
            padding-left: 24px;
        }
        @include point-lg{
            /*margin-bottom: 68px;*/
        }
        :deep(.def-h2){
            margin-bottom: 8px;
            @include point-md{
                margin-bottom: 12px;
            }
        }
        :deep(.def-slider__next){
            right: 0;
            transform: translate(50%, -50%);
        }
        :deep(.def-slider__prev){
            left: 0;
            transform: translate(-50%, -50%);
        }
        /*:deep(.def-slider__container){*/
        /*    margin-bottom: 0px;*/
        /*}*/
        :deep(.section-tag-card){
            height: 100%;
        }
    }
</style>